import { render, staticRenderFns } from "./Stat.vue?vue&type=template&id=64947a4a"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports